export const TERMS_CONDITION = {
    key: "1",
    value: "I agree to the terms and conditions",
};
export const SPRINT_VERSION = "3.2.6";
